// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 致远OA配置表单项
 * @constructor
 */
const SeeyonFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "username"]}
        label={"UserName"}
        placeholder={"请输入username"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入username"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "password"]}
        label={"Password"}
        placeholder={"请输入password"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入password"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "serverUrl"]}
        label={"ServerUrl"}
        placeholder={"请输入serverUrl"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入serverUrl"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default SeeyonFormItems
